var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explainClass"},[_c('img',{staticStyle:{"object-fit":"contain","height":"100vh"},attrs:{"src":"explain.png"}})])
}]

export { render, staticRenderFns }